import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AddAssetsToUxpTransferBatchMutationVariables = Types.Exact<{
  input: Types.AddAssetsToTransferBatchInput;
}>;


export type AddAssetsToUxpTransferBatchMutation = { __typename?: 'Mutation', addAssetsToTransferBatch?: { __typename?: 'AddAssetsToTransferBatchPayload', assetItems?: Array<{ __typename?: 'AssetItem', id: string, asset?: { __typename?: 'AudioAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'DocumentAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'FileAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'FolderAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'ImageAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'InteractiveAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'InteractiveLiveAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'ModelAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'UnsupportedAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'VersionStackAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | { __typename?: 'VideoAsset', id: string, uploadUrls?: Array<string | null> | null, project?: { __typename?: 'Project', id: string } | null } | null }> | null } | null };


export const AddAssetsToUxpTransferBatch = /*#__PURE__*/ gql`
    mutation AddAssetsToUxpTransferBatch($input: AddAssetsToTransferBatchInput!) {
  addAssetsToTransferBatch(input: $input) {
    assetItems {
      id
      asset {
        id
        uploadUrls(maxParts: 1000)
        project {
          id
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<AddAssetsToUxpTransferBatchMutation, AddAssetsToUxpTransferBatchMutationVariables>;

          

          export const useAddAssetsToUxpTransferBatchMutation = (options?:MutationHookOptions<AddAssetsToUxpTransferBatchMutation, AddAssetsToUxpTransferBatchMutationVariables>) => useMutation(AddAssetsToUxpTransferBatch, options);
          

          export type AddAssetsToUxpTransferBatchMutationOptions = MutationHookOptions<AddAssetsToUxpTransferBatchMutation, AddAssetsToUxpTransferBatchMutationVariables>;

          

          export type AddAssetsToUxpTransferBatchMutationResult = ReturnType<typeof useAddAssetsToUxpTransferBatchMutation>[1];

          
